<template>
  <div>
    <landing-create :content="landingCreateContent"></landing-create>
    <survey-form
      :isLoading="isLoading"
      :onSubmit="onSubmit"
    ></survey-form>
  </div>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import SurveyForm from './Form.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { medicalRegistry } = services;
const { formService } = medicalRegistry;

export default {
  name: 'FormCreate',
  components: {
    LandingCreate,
    SurveyForm,
  },
  data: () => ({
    isLoading: false,
    landingCreateContent: {
      pageTitle: 'Form Create',
      enableBackButton: true,
    },
  }),
  methods: {
    async onSubmit(data) {
      this.isLoading = true;
      try {
        const { _id: id } = await formService.create({ form: data });
        this.$snackbar.showOk({ text: 'Successfully created the form!' });
        this.$router.replace({ name: 'form.edit', params: { id } });
      } catch (e) {
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
      this.isLoading = false;
    },
  },
};
</script>
